module.exports = __webpack_public_path__ + "img/10_heart.346e47e9.jpg";